var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "500px" },
      model: {
        value: _vm.componentLocalDialog,
        callback: function($$v) {
          _vm.componentLocalDialog = $$v
        },
        expression: "componentLocalDialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title"),
          _c(
            "v-card-text",
            [
              _c(
                "v-container",
                [
                  _c(
                    "v-form",
                    { ref: "form" },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.$t("global.name"),
                                  rules: [
                                    function(v) {
                                      return (
                                        (v != null && v.length > 0) ||
                                        _vm.$t("global.error.required")
                                      )
                                    }
                                  ]
                                },
                                model: {
                                  value: _vm.componentLocalModel.name,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.componentLocalModel,
                                      "name",
                                      $$v
                                    )
                                  },
                                  expression: "componentLocalModel.name"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("v-text-field", {
                                attrs: { label: _vm.$t("global.defaultValue") },
                                model: {
                                  value: _vm.componentLocalModel.default_value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.componentLocalModel,
                                      "default_value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "componentLocalModel.default_value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("v-checkbox", {
                                attrs: { label: _vm.$t("global.isRequired") },
                                model: {
                                  value: _vm.componentLocalModel.is_required,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.componentLocalModel,
                                      "is_required",
                                      $$v
                                    )
                                  },
                                  expression: "componentLocalModel.is_required"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.close($event)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("global.cancel")))]
              ),
              _c(
                "v-btn",
                {
                  attrs: {
                    disabled: _vm.$store.getters["Ajax/loading"],
                    color: "blue darken-1",
                    text: ""
                  },
                  on: { click: _vm.save }
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.componentLocalModel.id === null
                          ? _vm.$t("global.add")
                          : _vm.$t("global.save")
                      ) +
                      " "
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }